import { useVariantContext } from "~/features/productDetails/context/VariantContext";
import CheckIcon from "@mui/icons-material/Check";
import { MenuItem, Select, Stack, styled, Typography, type MenuItemProps } from "~/common/mui";
import { QuantityStockIndicator } from "~/domains/product/components/StockIndicator/StockIndicator";
import Tag from "~/common/components/Tag/Tag";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { userIsCustomer } from "~/domains/user/utils/roles";

export const VariantSelect = () => {
  const { variantGroups, onSelectVariant, variantLoading } = useVariantContext();
  const isBusinessUser = userIsCustomer();

  if (!variantGroups || variantGroups.length === 0) {
    return null;
  }

  return (
    <Stack gap={2}>
      {variantGroups.map((group) => {
        const selectedOption = group.options.find((o) => o.selected);

        return (
          <Stack key={group.name} gap={1}>
            <Typography variant="labelMedium">{group.name}</Typography>

            <Select
              size="small"
              value={selectedOption?.value}
              renderValue={(value) => value || ""}
              onChange={(e) => {
                const selectedValue = e.target.value;
                const selectedOption = group.options.find((o) => o.value === selectedValue);

                if (selectedOption) {
                  onSelectVariant(selectedOption);
                  redirectToUrl(selectedOption.url);
                }
              }}
            >
              {group.options.map((option) => {
                return (
                  <VariantMenuItem
                    key={option.url}
                    selected={option.selected}
                    disabled={variantLoading}
                    value={option.value}
                  >
                    <Stack direction={"row"} gap={1.5}>
                      <CheckIcon
                        sx={{ visibility: option.selected ? "visible" : "hidden" }}
                        color={"onSecondaryContainer"}
                      />
                      <Typography>{option.value}</Typography>
                    </Stack>
                    {isBusinessUser && (
                      <Tag variant={option.stock ? "primary" : "default"}>
                        <QuantityStockIndicator quantity={option.stock} />
                      </Tag>
                    )}
                  </VariantMenuItem>
                );
              })}
            </Select>
          </Stack>
        );
      })}
    </Stack>
  );
};

export const VariantMenuItem = styled(MenuItem)<MenuItemProps & React.AnchorHTMLAttributes<HTMLAnchorElement> & { component?: React.ElementType }>({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "12px",
  width: "100%",
  height: "56px",
});
